import { createDynamicSlice } from ".";
import { fetchClientsThunk } from "../thunks/clientsThunk";

export const clientsSlice = createDynamicSlice({
  name: "clients",
  thunk: fetchClientsThunk,
  listMode: true,
  resetActionName: "resetClients",
});

export const clientsReducer = clientsSlice.reducer;
export const { resetClients } = clientsSlice.actions;
